<template>
    <div class="vue-map-sidebar" :class="{'active': hasActiveMarker}">
        <div class="inner" v-if="hasActiveMarker">
            <perfect-scrollbar>
                <img v-if="hasImage" :src="activeMarker.image" :alt="activeMarker.title">

                <button @click="handleClose" class="btn-close"></button>

                <div class="content-wrapper">
                    <h3>PartsPoint</h3>
                    <h4>{{ activeMarker.title }}</h4>

                    <ul class="details">
                        <li>{{ activeMarker.streetNumber }}</li>
                        <li>{{ activeMarker.postalCodePlace }} </li>
                        <li class="divider"></li>
                        <li><a :href="`tel:${parsedPhoneNumber}`">{{ activeMarker.tel }}</a></li>
                        <li><a :href="`mailto:${secureEmail}`" target="_blank">Email {{ activeMarker.title }}</a></li>
                    </ul>

                    <a v-if="hasGoogleInside" href="#" @click.prevent="handle360" class="btn-primary google-360-toggle">{{ googleInsideText }}</a>

                    <hr class="divider">

                    <div class="office-hours" v-html="activeMarker.officeHours"></div>

                    <a :href="`https://www.google.com/maps/dir//${ activeMarker.geoLocation.lat },${ activeMarker.geoLocation.lng }`" target="_blank" class="btn-secondary">{{ planRouteText }}</a>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';
import translations from "../../../../../themes/custom/ef2_custom/js/vue/mixins/translations";

export default {
    name: "MapSidebar",

    props: ['activeMarker', 'eventBus', 'hasActiveMarker'],

    mixins: [translations],

    computed: {
        parsedPhoneNumber() {
            if (_.isEmpty(this.activeMarker.tel)) {
                return;
            }

            return parsePhoneNumber(this.activeMarker.tel, 'NL').number;
        },

        hasGoogleInside() {
            return ! _.isEmpty(this.activeMarker.google360Url);
        },

        hasImage() {
            return ! _.isEmpty(this.activeMarker.image);
        },

        secureEmail() {
            return this.activeMarker.email.replaceAll('@','%40');
        }
    },

    methods: {
        handleClose() {
            this.eventBus.$emit('remove-active-marker');
        },

        handle360() {
            this.eventBus.$emit('open-360-wrapper', this.activeMarker.google360Url);
        }
    }
}
</script>